import React from "react";
import {Dashboard} from "../../core/_partials";

export function DashboardPage() {
  return <Dashboard />;
}
